import { render, staticRenderFns } from "./GeneralSettingsCheckoutPurchaseOrderAllowed.vue?vue&type=template&id=f65dc958&"
import script from "./GeneralSettingsCheckoutPurchaseOrderAllowed.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsCheckoutPurchaseOrderAllowed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports